var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMobileHome = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 512.002 420.001"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 34",
  transform: "translate(0 -46)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 188",
  d: "M75 46a15 15 0 00-12.481 6.68L2.576 142.6A15.42 15.42 0 000 151.105l22.223 10H256.5l10-10v-94.48L256.5 46H75z",
  fill: "#fb405c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 189",
  d: "M512 151.1a14.877 14.877 0 00-2.575-8.509L449.482 52.68A15 15 0 00437 46H256.5v115.1h234.147z",
  fill: "#e21959"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 190",
  d: "M0 151.1V391a15 15 0 0015 15h241.5l10-10V161.1l-10-10z",
  fill: "#fff2de"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 191",
  d: "M256.5 151.1V406H497a15 15 0 0015-15V151.1z",
  fill: "#fff2de"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 2",
  cx: 59.5,
  cy: 59.5,
  r: 59.5,
  transform: "translate(47.001 347.001)",
  fill: "#4c6080"
}), /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 3",
  cx: 29.5,
  cy: 29.5,
  r: 29.5,
  transform: "translate(77.001 377.001)",
  fill: "#e1e4ef"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 192",
  d: "M197 406.5a59.567 59.567 0 0059.5 59.5l10-30v-59l-10-30a59.567 59.567 0 00-59.5 59.5z",
  fill: "#4c6080"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 193",
  d: "M256.5 347v119a59.5 59.5 0 000-119z",
  fill: "#2e2e4d"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 194",
  d: "M227 406.5a29.533 29.533 0 0029.5 29.5l10-30-10-29a29.533 29.533 0 00-29.5 29.5z",
  fill: "#e1e4ef"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 195",
  d: "M256.5 377v59a29.5 29.5 0 000-59z",
  fill: "#ced5e5"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 196",
  d: "M212 196a15 15 0 00-15 15v90a15 15 0 0015 15h44.5l10-30v-60l-10-30z",
  fill: "#e0b978"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 197",
  d: "M302 196h-45.5v120H302a15 15 0 0015-15v-90a15 15 0 00-15-15z",
  fill: "#c8875b"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 198",
  d: "M227 226v60h29.5l10-30-10-30z",
  fill: "#b1715b"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 199",
  d: "M256.5 226H287v60h-30.5z",
  fill: "#7d4b3c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 200",
  d: "M152 196H62a15 15 0 00-15 15v90a15 15 0 0015 15h90a15 15 0 0015-15v-90a15 15 0 00-15-15z",
  fill: "#e0b978"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 201",
  d: "M77 226h60v60H77z",
  fill: "#b1715b"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 202",
  d: "M367 406v30l52 10 52-10v-30l-52-10z",
  fill: "#7d4b3c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 203",
  d: "M377 196a10 10 0 00-10 10v200h52l10-11V207.215L419 196z",
  fill: "#c8875b"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 204",
  d: "M471 206a10 10 0 00-10-10h-42v210h52z",
  fill: "#b1715b"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 205",
  d: "M471 436H367v20a10 10 0 0010 10h84a10 10 0 0010-10z",
  fill: "#c8875b"
}))));
export default SvgMobileHome;